import axios from "axios";
import { LOCALSTORAGE_TOKEN } from "../../config";

export async function getDashboardData() {
  let token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  let config = { headers: { Authorization: `bearer ${token}` } };

  const data = await axios.get(
    `${process.env.API_BASE_URL}/api/dashboard/`,
    config
  );
  return data.data;
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/services.js